/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Database_QuestionInputs */

const en_landing_faq_database_question = /** @type {(inputs: Landing_Faq_Database_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which databases can I use?`)
};

const zh_landing_faq_database_question = /** @type {(inputs: Landing_Faq_Database_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持哪些数据库？`)
};

/**
* | output |
* | --- |
* | "Which databases can I use?" |
*
* @param {Landing_Faq_Database_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_database_question = /** @type {((inputs?: Landing_Faq_Database_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Database_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_database_question(inputs)
	return zh_landing_faq_database_question(inputs)
});
export { landing_faq_database_question as "landing.faq.database.question" }